// extracted by mini-css-extract-plugin
module.exports = {"langWrapper":"styles_langWrapper__pDHzt","changeLanguageWrapper":"styles_changeLanguageWrapper__0EywS","selected":"styles_selected__tZAqu","lang":"styles_lang__pgd7g"};